import en from './en';
import de from './de';

export default {
    en: en,
    de: de,
};



// WEBPACK FOOTER //
// ./src/messages/index.js